// Warranty replacements (PO-xxxx-W), claim/hold re-orders (PO-xxxx-R) and
// orders Back Office manually marked as Reorder are pinned to the top of every
// production tab (after Rush) and tinted light red.
export const isWarrantyOrder = (o) => !!o?.is_warranty;
export const isReorderOrder = (o) => !!(o?.is_reorder || o?.reorder_flag);
export const isPriorityOrder = (o) => isWarrantyOrder(o) || isReorderOrder(o);

export const PRIORITY_ROW_CLS = "border-t border-red-200 bg-red-50 hover:bg-red-100/70";
export const PRIORITY_TAG_CLS = "bg-red-100 text-red-900 border border-red-300 font-bold text-[10px] uppercase tracking-widest";

// 3 Rush urgent · 2 Rush top · 1 Warranty / Reorder · 0 everything else
export function priorityRank(o) {
  if (o.rush_urgent || Number(o.rush_level || 0) >= 3) return 3;
  if (o.rush_top || Number(o.rush_level || 0) >= 2) return 2;
  if (isPriorityOrder(o)) return 1;
  return 0;
}

export function pinPriority(arr) {
  const top = arr.filter((o) => priorityRank(o) > 0).sort((a, b) => priorityRank(b) - priorityRank(a));
  return [...top, ...arr.filter((o) => priorityRank(o) === 0)];
}
